import { render, staticRenderFns } from "./agentEdit.vue?vue&type=template&id=b2b9fb3a&scoped=true&"
import script from "./agentEdit.vue?vue&type=script&lang=js&"
export * from "./agentEdit.vue?vue&type=script&lang=js&"
import style0 from "./agentEdit.vue?vue&type=style&index=0&id=b2b9fb3a&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2b9fb3a",
  null
  
)

export default component.exports